import React, { useEffect, useState } from 'react';
import './styles';
import UIListInputRow from '../../../../../components/UI/UIListInputRow';
import { UI_LABELED_INPUT_PHONE_NUMBER_TYPE, UI_LABELED_INPUT_TEXT_TYPE } from '../../../../../components/UI/UILabeledInput/config';
import Queries from '../../../../../utils/API/Queries';
import { toast } from 'react-toastify';
import { useApolloClient } from 'react-apollo';
import * as strings from './strings';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_INDIVIDUAL_EDITING_COMPANY_INFO } from './queries';

export default function IndividualEditingCompanyInfo({ editingCompanyId }: IndividualEditingCompanyInfoProps) {
	const [editingCompany, setEditingCompany] = useState<EditingCompanyType>();

	const [companyName, setCompanyName] = useState<string>('');
	const [companyEmail, setCompanyEmail] = useState<string>('');
	const [companyPhoneNumber, setCompanyPhoneNumber] = useState<string>('');

	const [isSaving, setIsSaving] = useState<object>({});

	const client = useApolloClient();

	const [getEditingCompany, { data: editingCompanyData }] = useLazyQuery(GET_INDIVIDUAL_EDITING_COMPANY_INFO, {
		variables: { id: editingCompanyId }
	});

	useEffect(() => {
		(async () => {
			await getEditingCompany();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (editingCompanyData) {
				const fetchedEditingCompany: EditingCompanyType = editingCompanyData['editingCompany'];
				setEditingCompany(fetchedEditingCompany);
				setCompanyName(fetchedEditingCompany.name);
				setCompanyEmail(fetchedEditingCompany.email);
				setCompanyPhoneNumber(fetchedEditingCompany.phoneNumber);
			}
		})();
	}, [editingCompanyData]);

	if (!editingCompany) return null;

	const onChangeCompanyInfo = (key, value, valueName) => {
		setIsSaving({ ...isSaving, [valueName]: true });

		client
			.mutate({
				mutation: Queries.UPDATE_EDITING_COMPANY,
				variables: { id: editingCompany.id, [key]: value }
			})
			.then(async (response) => {
				const { updateEditingCompany } = response['data'];
				if (!updateEditingCompany) {
					toast.error(strings.updateError);
				} else {
					await getEditingCompany();
					delete isSaving[valueName];
					setIsSaving(isSaving);
					toast.success(strings.updateSuccess);
				}
			});
	};

	return (
		<div className='companyInfo'>
			<p className='page-title'>Company Info</p>
			<UIListInputRow
				containerStyle={{ marginBottom: 8, width: 360 }}
				label={'name'}
				style={{ width: '100%' }}
				type={UI_LABELED_INPUT_TEXT_TYPE}
				placeholder={strings.companyNamePlaceholder}
				onChangeValue={setCompanyName}
				value={companyName}
				isLoading={isSaving['companyName']}
				savedValue={editingCompany.name}
				onSave={() => onChangeCompanyInfo('name', companyName, 'companyName')}
			/>
			<UIListInputRow
				containerStyle={{ marginBottom: 8, width: 360 }}
				label={'e-mail'}
				style={{ width: '100%' }}
				type={UI_LABELED_INPUT_TEXT_TYPE}
				onChangeValue={setCompanyEmail}
				value={companyEmail}
				isLoading={isSaving['companyEmail']}
				savedValue={editingCompany.email}
				onSave={() => onChangeCompanyInfo('email', companyEmail, 'companyEmail')}
				placeholder={strings.companyEmailPlaceholder}
			/>
			<UIListInputRow
				type={UI_LABELED_INPUT_PHONE_NUMBER_TYPE}
				label={'phone number'}
				onChangeValue={setCompanyPhoneNumber}
				value={companyPhoneNumber}
				isLoading={isSaving['companyNumber']}
				savedValue={editingCompany.phoneNumber}
				onSave={() => onChangeCompanyInfo('phoneNumber', companyPhoneNumber, 'companyNumber')}
				placeholder={strings.companyPhoneNumberPlaceholder}
			/>
		</div>
	);
}
